// FILE: frontend/src/components/LessonSelect.jsx
// Lesson selection view with level picker (Patricia's design)

import React from 'react'

const LEVELS = [
  { code: 'A1', name: 'Beginner' },
  { code: 'A2', name: 'Elementary' },
  { code: 'B1', name: 'Intermediate' },
  { code: 'B2', name: 'Upper Intermediate' },
  { code: 'C1', name: 'Advanced' },
  { code: 'C2', name: 'Proficient' },
]

export default function LessonSelect({
  lessons,
  lessonSource,
  selectedLesson,
  selectedLevel,
  mode,
  error,
  onSelectLesson,
  onSelectLevel,
  onSelectSource,
  onSelectMode,
  onLocalFiles,
  onStart,
  onClearError,
  isConnecting = false,
}) {
  const selectedObj = lessonSource === 'api' ? lessons.find(l => l.id === selectedLesson) : null
  const selectedLocked = Boolean(selectedObj?.locked)
  const selectedUsed = selectedObj?.attempts_used ?? 3
  const selectedLimit = selectedObj?.attempts_limit ?? 3

  const startDisabled =
    isConnecting ||
    (mode === 'practice' &&
    (!selectedLesson || (lessonSource === 'api' && selectedLocked)))

  return (
    <div className="sqa-select-container">
      <div className="sqa-select-header">
        <h1>Choose Your Lesson</h1>
        <p>Interactive voice conversation practice</p>
      </div>

      {/* Mode selector (practice only for now — test disabled) */}
      {/* Uncomment when placement tests are re-enabled:
      <div className="sqa-form-group">
        <label>Mode</label>
        <div style={{ display: 'flex', gap: 10 }}>
          <button
            className={`sqa-btn ${mode === 'practice' ? 'sqa-btn-primary' : 'sqa-btn-secondary'}`}
            onClick={() => { onSelectMode('practice'); onClearError() }}
          >
            Practice Lesson
          </button>
          <button
            className={`sqa-btn ${mode === 'test' ? 'sqa-btn-primary' : 'sqa-btn-secondary'}`}
            onClick={() => { onSelectMode('test'); onClearError() }}
          >
            Placement Test
          </button>
        </div>
      </div>
      */}

      {mode === 'practice' && (
        <>
          

          {/* Lesson dropdown */}
          <div className="sqa-form-group">
            <label>Lesson</label>
            <select
              value={selectedLesson}
              onChange={e => onSelectLesson(e.target.value)}
              className="sqa-select-input"
            >
              {lessons.length === 0 ? (
                <option value="">Loading lessons...</option>
              ) : (
                lessons.map(lesson => {
                  const used = Number(lesson.attempts_used ?? 0)
                  const limit = Number(lesson.attempts_limit ?? 3)
                  const locked = Boolean(lesson.locked)
                  const suffix = lessonSource === 'api' ? ` ${used}/${limit}` : ''
                  return (
                    <option key={lesson.id} value={lesson.id} disabled={locked}>
                      {lesson.title}{suffix}
                    </option>
                  )
                })
              )}
            </select>

            {lessonSource === 'api' && selectedLocked && (
              <div className="sqa-error" style={{ marginTop: 10 }}>
                Attempts used ({selectedUsed}/{selectedLimit}). Choose another lesson.
              </div>
            )}
          </div>

          {/* Level picker */}
          <div className="sqa-form-group">
            <label>Level</label>
            <div className="sqa-level-grid">
              {LEVELS.map(level => (
                <button
                  key={level.code}
                  className={`sqa-level-btn ${selectedLevel === level.code ? 'active' : ''}`}
                  onClick={() => onSelectLevel(level.code)}
                >
                  <strong>{level.code}</strong>
                  <span>{level.name}</span>
                </button>
              ))}
            </div>
          </div>
        </>
      )}

      {/* Instructions */}
      <div className="sqa-instructions">
        <h3>Instructions</h3>
        <ul>
          <li>Use headphones or earbuds for best results</li>
          <li>Click "Start" and allow microphone access</li>
          <li>Speak naturally when the AI asks you questions</li>
          {mode === 'practice'
            ? <li>Complete all goals to finish the lesson</li>
            : <li>Answer questions until the placement test completes</li>
          }
        </ul>
      </div>

      {/* Error */}
      {error && <div className="sqa-error">{error}</div>}

      {/* Start button */}
      <button
        className="sqa-start-btn"
        onClick={onStart}
        disabled={startDisabled}
        style={isConnecting ? { opacity: 0.7, cursor: 'wait' } : undefined}
      >
        {isConnecting
          ? 'Connecting...'
          : mode === 'test' ? 'Start Placement Test →' : 'Start Practice →'
        }
      </button>
    </div>
  )
}
